import React, { useContext, useState } from 'react';
import MyButton from '../../UI/MyButton/MyButton';
import MyInput from '../../UI/MyInput/MyInput';
import Divider from '../../UI/Divider/Divider';
import { MainContext } from '../../..';
import { useNavigate } from 'react-router';
import { CABINET_ROUTE } from '../../../utils/consts';
import { getOneUser, login } from '../../../API/userApi';
import { getOneEmployee } from '../../../API/employeeApi';

const EnterForm = ({ setCurrentScreen }) => {
    const [userLogin, setUserLogin] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const { user } = useContext(MainContext);
    const navigate = useNavigate();

    const loginFunc = async (userLogin, password) => {
        try {
            const data = await login(userLogin, password);
            user.setIsAuth(true);
            const newUser = await getOneUser(data.user_id);
            const newEmployee = await getOneEmployee(data.user_id);
            user.setUser(newUser);
            user.setEmployee(newEmployee);
            // console.log(user);
            navigate(CABINET_ROUTE);
        } catch (e) {
            console.log(e);
            alert(e.response.data.error);
        }
    };

    return (
        <div className="enterForm">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        marginBlock: 30,
                        fontSize: 36,
                        color: 'rgba(15, 48, 61, 1)',
                        fontWeight: 'bold',
                    }}
                >
                    Вход
                </div>
                <MyButton
                    style={{ marginBlock: 30, fontWeight: 'bold', width: 180, height: 35 }}
                    // onClick={() => setCurrentScreen('choose-registration')}
                    onClick={() => setCurrentScreen('registrate-medical-worker')}
                >
                    К регистрации
                </MyButton>
            </div>

            <label htmlFor="telelphoneOrEmailOrID">Логин</label>
            <MyInput
                id="telelphoneOrEmailOrID"
                name="telelphoneOrEmailOrID"
                type="text"
                value={userLogin}
                placeholder="Введите логин"
                onChange={(e) => setUserLogin(e.target.value)}
            />
            <label htmlFor="password">Пароль</label>
            <MyInput
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                placeholder="Введите пароль"
                onChange={(e) => setPassword(e.target.value)}
            />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <MyInput
                        style={{ width: 20, height: 20, marginRight: 10 }}
                        id="showPassword"
                        type="checkbox"
                        checked={showPassword}
                        onChange={(e) => setShowPassword(e.target.checked)}
                    />
                    <label
                        htmlFor="showPassword"
                        style={{ color: 'rgba(98, 98, 96, 1)', fontSize: 16 }}
                    >
                        Показать пароль
                    </label>
                </div>
                {/* <MyButton>Восстановить пароль</MyButton> */}
            </div>
            <MyButton
                onClick={() => loginFunc(userLogin, password)}
                style={{
                    display: 'flex',
                    width: '100%',
                    marginBlock: 30,
                    padding: 15,
                    backgroundColor: 'rgba(97, 126, 198, 1)',
                    borderColor: 'rgba(97, 126, 198, 1)',
                    color: 'white',
                }}
            >
                ВОЙТИ
            </MyButton>
            {/* <Divider />
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    margin: '30px 0px 10px 0px',
                    fontWeight: 'bold',
                }}
            >
                Войти через
            </div>
            <MyButton
                style={{
                    display: 'flex',
                    width: '100%',
                    padding: 15,
                    fontSize: 24,
                }}
            >
                QR-код
            </MyButton> */}
        </div>
    );
};

export default EnterForm;

